import React, { FC } from 'react';
import { ProjectDetailsFieldsProps } from './ProjectDetailsFieldsProps';
import CustomInput from '../../../common/CustomInput';
import useTranslation from '../../../hooks/useTranslation';
import ProjectNameInput from '../ProjectNameInput';
import EstablishmentTypeInput from '../../EstablishmentTypeInput';
import DependencyProjectInput from '../../DependencyProjectInput';

const ProjectDetailsFields: FC<ProjectDetailsFieldsProps> = ({
  projectList,
  unifier,
  type,
  isRealEstateSisan,
}) => {
  const t = useTranslation();
  return (
    <>
      <ProjectNameInput />
      <DependencyProjectInput projects={projectList} />
      <EstablishmentTypeInput defaultValue={type} />
      {unifier && (
        <CustomInput
          name={'unifierId'}
          label={t('labels.unifierId')}
          helperText={t('labels.unifierIdHelperText')}
          dataTestID={'unifier-id'}
          disabled={isRealEstateSisan}
          disabledOnAll={false}
        />
      )}
    </>
  );
};

export default ProjectDetailsFields;
